export default __webpack_public_path__ + "static/media/fmbmi-blood.501e9e7f.png";